import { render, staticRenderFns } from "./NewsCardPoster.vue?vue&type=template&id=2cdd3ea9"
import script from "./NewsCardPoster.vue?vue&type=script&lang=js"
export * from "./NewsCardPoster.vue?vue&type=script&lang=js"
import style0 from "./NewsCardPoster.vue?vue&type=style&index=0&id=2cdd3ea9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports